export enum UploadType {
  NEW_DOCUMENT = 'new_document',
  UPDATED_DOCUMENT = 'updated_document',
  UPDATED_METADATA = 'updated_metadata',
}

export enum MetadataModalMode {
  NORMAL = 'normal',
  COMPARISON = 'comparison',
}
